import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { createClient } from "../api/clientApi";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import {
  CountrySelector,
  MobileCodeSelector,
} from "../components/Selectors/Country";
import countriesData from "../data/countries.json";

const Register = () => {
  const { setClientData } = useAuth();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    mode: "onBlur", // This triggers validation when inputs lose focus
  });
  const [loading, setLoading] = useState(false); // Loading state for form submission
  const selectedCountry = watch("country");
  React.useEffect(() => {
   
      setValue("mobileCode",'974');

  }, []);
  // Update mobile code when country changes
  React.useEffect(() => {
    if (selectedCountry) {
     
      var code = countriesData.filter((option) =>
        option.countryCode.toLowerCase().includes(selectedCountry.toLowerCase())
      );
      console.log(code[0].dialCode);
      setValue("mobileCode", code[0]?.dialCode);
    }
  }, [selectedCountry, setValue]);

  const handleFormSubmit = async (data) => {
    setLoading(true); // Start loading indicator
    try {
      const { terms,mobileCode, ...cleanData } = data; // Destructure to remove 'terms'
      const processedData = {
        ...cleanData, // Spread the rest of the data
        date_created: new Date(),
        mobile: data.mobileCode+data.mobile,
      };
      console.log(processedData);
      // Call the API to create the client
      const clientData = await createClient(processedData);
      console.log(clientData);
      setClientData(clientData);
      toast.success(t("registeredSusccss"), {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    //   navigate("/");
      reset(); // Reset form fields after success
    } catch (error) {
      toast.error(`Error: ${error.message || "Something went wrong"}`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };

  return (
    <div className="min-h-screen bg-[#fdf6ec] flex flex-col items-center justify-start p-0">
      <div className="relative w-[75%] sm:w-[90%] max-[450px]:w-[95%] flex justify-end flex-col items-center  bg-white rounded-t-none rounded-b-3xl  shadow-lg px-4   pt-6 space-y-0">
        <div className="space-y-2 mb-2 sm:mb-2">
          <h1 className="text-3xl max-[450px]:text-lg font-bold text-black">
            {t("welcome")}
          </h1>
          <h1 className="text-3xl max-[450px]:text-lg font-bold text-black ">
            <span className="font-eightOne  tracking-wider">DELIRE</span> PERFUMES
          </h1>
        </div>

        <>
          <div className="space-y-6 w-[85%] max-[450px]:w-[95%]  lg:w-[50%] py-10 ">
            <h2 className="text-xl font-bold text-[#0a2942]">{t('signUp')}</h2>
            <form id="signup-form" onSubmit={handleSubmit(handleFormSubmit)}>        

              {/* Name Input */}
              <div className="space-y-2">
                <label htmlFor="username" className="text-sm font-medium">
                  {t("username")}
                </label>
                <input
                  id="username"
                  type="text"
                  {...register("username", { required: t("usernamereq") })}
                  className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.username ? "border-red-500" : ""
                  }`}
                />
                {errors.username && (
                  <p className="text-xs text-red-500">
                    {errors.username.message}
                  </p>
                )}
              </div>

              {/* Email Input */}
              <div className="space-y-2">
                <label htmlFor="email" className="text-sm font-medium">
                  {t("email")}
                </label>
                <input
                  id="email"
                  type="email"
                  {...register("email", {
                    required: t("emailreq"),
                    pattern: {
                      value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                      message: t("emailval"),
                    },
                  })}
                  className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.email ? "border-red-500" : ""
                  }`}
                />
                {errors.email && (
                  <p className="text-xs text-red-500">{errors.email.message}</p>
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="country" className="text-sm font-medium">
                  {t("country")}
                </label><Controller
                name="country"
                control={control}
                rules={{ required: t('countryreq') }}
                render={({ field, fieldState: { error } }) => (
                  <CountrySelector {...field} error={error?.message} />
                )}
              />
              </div>
              <div className="space-y-2">
                <label htmlFor="address" className="text-sm font-medium">
                  {t("address")}
                </label>
                <input
                  id="address"
                  type="text"
                  placeholder="bldg ,street ,city , zone "
                  {...register("address", { required: t("addressreq") })}
                  className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.address ? "border-red-500" : ""
                  }`}
                />
                {errors.address && (
                  <p className="text-xs text-red-500">
                    {errors.address.message}
                  </p>
                )}
              </div>
              {/* Mobile Number Input */}
              <div className="space-y-2 ">
                <div>
                  <label htmlFor="mobile" className="text-sm font-medium">
                    {t("mobile")}
                  </label>
                  <div className=" flex items-center">
                      <Controller
                        name="mobileCode"
                        control={control}
                        rules={{ required: "code is required" }}
                        render={({ field, fieldState: { error } }) => (
                          <MobileCodeSelector
                            {...field}
                            error={error?.message}
                          />
                        )}
                      />
                      <input
                      id="mobile"
                      type="tel"
                      {...register("mobile", {
                        required: t("mobilereg"),
                        pattern: {
                          value: /^\d{8}$/,
                          message: t('mobileval'),
                        },
                      })}
                      className={`w-full  px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                        errors.mobile ? "border-red-500" : ""
                      }`}
                      placeholder="XXXXXXXX"
                    />
                  
                  </div>
                  {errors.mobile && (
                    <p className="text-xs text-red-500 mt-1">
                      {errors.mobile.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="space-y-2">
                <label htmlFor="password" className="text-sm font-medium">
                  {t("password")}
                </label>
                <input
                  id="password"
                  type="password"
                  {...register("password", {
                    required: t("passwordreq"),
                    pattern: {
                      value:
                        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{}|;:'",.<>/?]).{8,10}$/,
                      message: t("passwordval"),
                    },
                  })}
                  className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.password ? "border-red-500" : ""
                  }`}
                />
                {errors.password && (
                  <p className="text-xs text-red-500">
                    {errors.password.message}
                  </p>
                )}
              </div>
              <div className="space-y-2 space-x-2">
                <label htmlFor="terms" className="text-sm font-medium">
                  {t("iagree")}{" "}
                  <a
                    href="https://www.example.com/terms-and-conditions"
                    target="_blank"
                    className="text-[#47b5ff]"
                    rel="noreferrer"
                  >
                    {t("termsConditions")}
                  </a>
                </label>
                <input
                  id="terms"
                  type="checkbox"
                  {...register("terms", {
                    required: t("tmval"),
                  })}
                  className={`w-4 h-4 rounded-md bg-[#f0f9ff] border-2 border-[#47b5ff] focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.terms ? "border-red-500" : ""
                  }`}
                />
                {errors.terms && (
                  <p className="text-xs text-red-500">{errors.terms.message}</p>
                )}
              </div>

              <input
                {...register("status", { required: true })}
                placeholder="status"
                type="hidden"
                className="w-full p-2 border rounded-full mb-3"
                value={"Active"}
              />
            </form>
          </div>
          <div className="absolute w-[85%] max-[450px]:w-[80%]   lg:w-[50%] bottom-0 translate-y-1/2 ">
            <button
              disabled={isSubmitting || loading}
              onClick={() =>
                document
                  .getElementById("signup-form")
                  .dispatchEvent(
                    new Event("submit", { cancelable: true, bubbles: true })
                  )
              }
              className="w-full bg-slate-800 hover:bg-[#ff9933] text-white font-bold py-4 max-[450px]:py-2  rounded-full transition duration-200"
            >
              {loading ? t("submitting") : t("register")}
            </button>
          </div>
        </>
      </div>
      <div className="text-center mt-9">
        <p className="text-[#0a2942]">
          {t('haveaccount')}
          <a href="/login" className="font-bold hover:underline">
            {t('login')}.
          </a>
        </p>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Register;
